import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { RatingSquare, RatingContent, RatingNestedContent, HorizontalLine, Level, SmallerRatingHeader, EmailLink } from '../../components/rating';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Content Rating`}</h2>
    <p>{`GIFs are for everyone, and GIPHY is committed to making sure that its GIF search is a positive experience for everyone. We take content safety extremely seriously. Our GIF and Sticker library is thoroughly moderated and organized by rating in order to give GIPHY users the safest possible search experience. We do not hesitate to remove content that falls outside of our Community Guidelines.`}</p>
    <h6>{`Content Rating Levels`}</h6>
    <RatingContent mdxType="RatingContent">
    <RatingSquare gradient="linear-gradient(to bottom right, #00FF99, #00CCFF)" mdxType="RatingSquare">
        <h1>G</h1>
        <h5>Level 1</h5>
    </RatingSquare>
    <RatingNestedContent mdxType="RatingNestedContent">
        <h6>
            Contains images that are broadly accepted as appropriate and commonly witnessed by people in a public
            environment.
        </h6>
        <div>
            🚫 No profanity
            <br />
            🚫 No sexual content - real or animated (no innuendo or partial nudity, nothing provocative)
            <br />
            🚫 No violence or threatening imagery
            <br />
            🚫 No weapons (finger, water, and Nerf guns are exceptions)
            <br />
            🚫 No substances/drugs
        </div>
    </RatingNestedContent>
    </RatingContent>
    <HorizontalLine mdxType="HorizontalLine" />
    <RatingContent mdxType="RatingContent">
    <RatingSquare gradient="linear-gradient(to bottom right, #00CCFF, #3191FF)" mdxType="RatingSquare">
        <SmallerRatingHeader mdxType="SmallerRatingHeader">PG</SmallerRatingHeader>
        <h5>Level 2</h5>
    </RatingSquare>
    <RatingNestedContent mdxType="RatingNestedContent">
        <h6>
            Contains images that are commonly witnessed in a public environment, but not as broadly accepted as
            appropriate.
        </h6>
        <ul>
            <li>Mild profanity (ex: butt, hell, damn, suck, etc.)</li>
            <li>Mild bathroom humor</li>
            <li>Mild sexual content (ex: kissing on the lips, fully clothed provocative body movements.)</li>
            <li>
                Mild violence (yelling angrily, smashing inanimate objects, fails, facetious references to acts of
                violence, etc.)
            </li>
            <li>
                Images that feature real guns in holsters and people aiming or shooting non realistic looking guns from
                pop culture
            </li>
            <li>Images with medieval weapons with no blood and mild duels without injury</li>
            <li>
                Mildly abnormal or frightening activities, movements, or gestures (ex: spooky images from horror movies
                without gore, horror makeup, etc.)
            </li>
            <li>
                Images of tobacco and alcohol, their brand names, and mild usage (ex: sipping, cheers, holding
                cigarettes, etc.)
            </li>
        </ul>
    </RatingNestedContent>
    </RatingContent>
    <HorizontalLine mdxType="HorizontalLine" />
    <RatingContent mdxType="RatingContent">
    <RatingSquare gradient="linear-gradient(to bottom right, #FFF35C, #FF9F00)" mdxType="RatingSquare">
        <h2>PG</h2>
        <h2>13</h2>
        <Level mdxType="Level">Level 3</Level>
    </RatingSquare>
    <RatingNestedContent mdxType="RatingNestedContent">
        <h6>Contains images that are typically not seen unless sought out, but still commonly witnessed.</h6>
        <ul>
            <li>Moderate profanity and implied abbreviations (ex: human anatomy, names of drugs, wtf, etc.)</li>
            <li>Use of middle finger as a rude gesture</li>
            <li>
                Sexual content and themes, including sexual innuendo with no nudity (ex. making out, sexually suggestive
                movements, references to sex acts)
            </li>
            <li>Exploitation of the human body while partially covered</li>
            <li>Images featuring non-gushing blood in a violent context</li>
            <li>
                Moderately violent or threatening behaviour or gestures (ex: pointing a knife, excerpts from horror
                movies, knockouts, injury)
            </li>
            <li>Realistic guns (ex: guns being held, pointed, shot, etc.)</li>
            <li>Heavy use of alcohol (ex: chugging, keg stands, beer bogs, etc.)</li>
            <li>References to marijuana, illegal drug use, and fictional images of use</li>
            <li>Challenging religion or religious figures</li>
        </ul>
    </RatingNestedContent>
    </RatingContent>
    <HorizontalLine mdxType="HorizontalLine" />
    <RatingContent mdxType="RatingContent">
    <RatingSquare gradient="linear-gradient(to bottom right, #9933FF, #FF6666)" mdxType="RatingSquare">
        <h1>R</h1>
        <h5>Level 4</h5>
    </RatingSquare>
    <RatingNestedContent mdxType="RatingNestedContent">
        <h6>
            Contains images that are typically not seen unless sought out and could be considered alarming if witnessed.
        </h6>
        <ul>
            <li>Severe profanity</li>
            <li>
                Nonpornographic images with strong sexual themes and innuendo, very revealing clothing, main focus on
                bodies, and otherwise arousing images with partial nudity.
            </li>
            <li>Crudely drawn or humorous cartoons or CGI that depicts genitalia</li>
            <li>
                Imagery and content from movies, TV, and video games that is highly disturbing, alarming, distressing,
                or dark, even if there is no gore
            </li>
            <li>Any simulated violence with gore</li>
            <li>Heavy use of illegal drugs in a fictional settings</li>
            <li>Very crude and vulgar humor</li>
        </ul>
    </RatingNestedContent>
    </RatingContent>
    <HorizontalLine mdxType="HorizontalLine" />
    <p>{`Please contact `}<EmailLink href="mailto:support@giphy.com<" mdxType="EmailLink">{`support@giphy.com`}</EmailLink>{` if you see any content that you feel is incorrectly rated or in violation of GIPHY’s Community Guidelines. Also, feel free to reach out if you have any general questions about content safety at GIPHY as well.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      